var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPadlock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 21,
    viewBox: "0 0 17 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.3333 11H2.66667C1.74619 11 1 11.7326 1 12.6364V18.3636C1 19.2674 1.74619 20 2.66667 20H14.3333C15.2538 20 16 19.2674 16 18.3636V12.6364C16 11.7326 15.2538 11 14.3333 11Z",
    stroke: "#0086D6",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.70898 5.85453C3.70898 4.62478 4.1975 3.44541 5.06706 2.57585C5.93662 1.70629 7.11599 1.21777 8.34574 1.21777C9.57548 1.21777 10.7549 1.70629 11.6244 2.57585C12.494 3.44541 12.9825 4.62478 12.9825 5.85453V11.0002",
    stroke: "#0086D6",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPadlock);
export default __webpack_public_path__ + "static/media/icon-padlock.29d87d783e58d09eadcfbed3921fe1e6.svg";
export { ForwardRef as ReactComponent };